export type SocialMediaItem = {
    name: string;
    url: string;
    image: string;
}

// todo: add social media for other countries as well!
export const socialMediaCz: SocialMediaItem[] = [
    {
        name: 'Instagram',
        url: "https://www.instagram.com/trisbeecom/?hl=cs",
        image: "/static/images/socials/personal/ig.svg",
    },
    {
        name: 'Facebook',
        url: "https://www.facebook.com/trisbeecom/",
        image: "/static/images/socials/personal/fb.svg",
    },
    {
        name: 'LinkedIn',
        url: "https://www.linkedin.com/company/trisbee/",
        image: "/static/images/socials/personal/li.svg",
    },
]
